import { ValidityStatus } from 'interfaces';

export function resolveValidity(data?: Record<string, ValidityStatus>): ValidityStatus {
    return Object.values(data || {}).reduce<ValidityStatus>((acc: ValidityStatus, val: ValidityStatus) => {
        if (acc === 'Invalid' || val === 'Invalid' || acc === 'Pristine' || val === 'Pristine') {
            return 'Invalid';
        } else if (acc === 'Pending' || val === 'Pending') {
            return 'Pending';
        } else if (acc === 'Warning' || val === 'Warning') {
            return 'Warning';
        } else {
            return 'Valid';
        }
    }, 'Valid');
}

export function isRejectedValidityStatus(validityStatus: ValidityStatus): boolean {
    return [ 'Invalid', 'Pending', 'Pristine' ].includes(validityStatus);
}

export function isAcceptedValidityStatus(validityStatus: ValidityStatus): boolean {
    return [ 'Valid', 'Warning' ].includes(validityStatus);
}

export function getValidityStatus(value?: string): ValidityStatus {
    return value ? 'Valid' : 'Invalid';
}
